const NAME = "ORGCHART";

export default NAME;
